import Avatar from 'components/base/Avatar';
import { useState } from 'react';
import { Card, Dropdown, Nav } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import Scrollbar from 'components/base/Scrollbar';
import classNames from 'classnames';
/* Authtentication side */
import { useAuth } from 'providers/AuthProvider'
import { useTranslation } from 'react-i18next';

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const [navItems] = useState([
    {
      label: 'Profile',
      icon: 'user',
      link: 'users/profile'
    },
    {
      label: 'Dashboard',
      icon: 'pie-chart',
      link: '/dashboard/home'
    },
    {
      label: 'Settings & Privacy ',
      icon: 'settings',
      link: '/settings'
    },
    /*
    {
      label: 'Help Center',
      icon: 'help-circle',
      link: '/dashboard/home'
    },
    {
      label: 'Language',
      icon: 'globe',
      link: '/dashboard/home'
    }*/
  ]);

  const auth = useAuth();

  const { t } = useTranslation();

  //const { closeSocket } = useSSE();

  function handleLogout() {
    //console.log("handleLogout");
    auth.signout(() => { });
    //closeSocket();
  }

  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border border-300'
      )}
    >
      <Card className="position-relative border-0">
        <Card.Body className="p-0">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
            {auth.user && <Avatar src={auth.user.picture} size="xl" />}
            {auth.user && <h6 className="text-black">{auth.user.full_name}</h6>}
          </div>

          <div style={{ height: '8rem' }}>
            <Scrollbar>
              <Nav className="nav flex-column mb-1 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Link
                      to={item.link}
                      className="px-3 nav-link"
                    >
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-900"
                      />
                      <span className="text-1000">{item.label}</span>
                    </Link>
                    {/*
                    <Nav.Link href={item.link} className="px-3">
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-900"
                      />
                      <span className="text-1000">{item.label}</span>
                    </Nav.Link>
*/}
                  </Nav.Item>
                ))}
              </Nav>
            </Scrollbar>
          </div>
        </Card.Body>

        <Card.Footer className="p-0 border-top">
          {/* }
          <Nav className="nav flex-column my-3">
            <Nav.Item>
              <Nav.Link href="#!" className="px-3">
                <FeatherIcon
                  icon="user-plus"
                  size={16}
                  className="me-2 text-900"
                />
                <span>{t("ProfileDropdownMenu.add_another_account")}</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <hr />
          */}
          <div className="my-3 px-3">
            <Link
              to="/" onClick={handleLogout}
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              Sign out
            </Link>
          </div>
          {/* 
          <div className="my-2 text-center fw-bold fs-10 text-600">
            <Link className="text-600 me-1" to="#!">
              Privacy policy
            </Link>
            •
            <Link className="text-600 mx-1" to="#!">
              Terms
            </Link>
            •
            <Link className="text-600 ms-1" to="#!">
              Cookies
            </Link>
          </div>
          */}
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default ProfileDropdownMenu;
